import { useContext } from "react";
import { useSelector } from "react-redux";
import { ListEditionError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: ListEditionError;
  editList(request: Boundaries["editList"]["request"]): void;
}

function useListEdition(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isListEditionRequestPending),
    isRequestSuccess: useSelector(selector.isListEditionRequestSuccess),
    isRequestFailure: useSelector(selector.isListEditionRequestFailure),
    error: useSelector(selector.getListEditionError),
    editList: core.editList,
  };
}

export { useListEdition };
